import { ComponentType } from "react";

import { BaseComponentProps } from "@keepeek/refront-components";

import { WidgetConfigurations } from "../../../containers/widgets/models";
import { Template } from "../../../models/configuration/definitions/template";
import MediaDetailFixed from "./MediaDetailFixed";
import MediaDetailScroll from "./MediaDetailScroll";

export type MediaDetailMode = "scroll" | "fixed";

export type SpecificMediaDetailProps = {
  widgetsConfiguration: WidgetConfigurations | null;
  templatesConfiguration: Template[];
} & BaseComponentProps;
type Mapping = {
  [key in MediaDetailMode]: ComponentType<React.PropsWithChildren<SpecificMediaDetailProps>>;
};

export const mediaDetailModeMapping: Mapping = {
  scroll: MediaDetailScroll,
  fixed: MediaDetailFixed,
};
